"use client";
/*
 * Documentation:
 * Icon with logo background — https://app.subframe.com/06b570ce924b/library?component=Icon+with+logo+background_033719f9-493d-41fe-8d83-6788303a039c
 */

import React from "react";
import { FeatherCheck } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface IconWithLogoBackgroundRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "brand" | "neutral" | "error" | "success" | "warning" | "beige";
  size?: "x-large" | "large" | "medium" | "small" | "x-small";
  icon?: React.ReactNode;
  className?: string;
}

const IconWithLogoBackgroundRoot = React.forwardRef<
  HTMLDivElement,
  IconWithLogoBackgroundRootProps
>(function IconWithLogoBackgroundRoot(
  {
    variant = "brand",
    size = "x-small",
    icon = <FeatherCheck />,
    className,
    ...otherProps
  }: IconWithLogoBackgroundRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/033719f9 flex h-5 w-5 items-center justify-center gap-2 rounded-full relative",
        {
          "h-6 w-6": size === "small",
          "h-8 w-8": size === "medium",
          "h-12 w-12": size === "large",
          "h-16 w-16": size === "x-large",
        },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {icon ? (
        <SubframeCore.IconWrapper
          className={SubframeUtils.twClassNames(
            "font-['Inter'] text-[10px] font-[400] leading-[12px] text-primary-navy-800 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10",
            {
              "text-caption font-caption": size === "small",
              "text-body font-body": size === "medium",
              "text-heading-2 font-heading-2": size === "large",
              "text-heading-1 font-heading-1 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10":
                size === "x-large",
              "text-secondary-beige-600": variant === "beige",
              "text-warning-800": variant === "warning",
              "text-success-800": variant === "success",
              "text-error-800": variant === "error",
              "text-neutral-700": variant === "neutral",
            }
          )}
        >
          {icon}
        </SubframeCore.IconWrapper>
      ) : null}
      <img
        className={SubframeUtils.twClassNames(
          "grow shrink-0 basis-0 self-stretch object-contain",
          { block: size === "x-large" }
        )}
        src={
          variant === "beige"
            ? "https://res.cloudinary.com/subframe/image/upload/v1768819849/uploads/17807/vjyk1ucozau4gdsfzvd5.svg"
            : variant === "warning"
            ? "https://res.cloudinary.com/subframe/image/upload/v1768820198/uploads/17807/h48zlfebs0ywgr0whoid.svg"
            : variant === "success"
            ? "https://res.cloudinary.com/subframe/image/upload/v1768819829/uploads/17807/yvzertyn0e1xicoajzhy.svg"
            : variant === "error"
            ? "https://res.cloudinary.com/subframe/image/upload/v1768820157/uploads/17807/lrghr5hvczece73vn3vn.svg"
            : variant === "neutral"
            ? "https://res.cloudinary.com/subframe/image/upload/v1768819811/uploads/17807/t5rgm8qkuejmun7w5tt7.svg"
            : "https://res.cloudinary.com/subframe/image/upload/v1768819742/uploads/17807/kakuyvglaxj9bnf0aaju.svg"
        }
      />
    </div>
  );
});

export const IconWithLogoBackground = IconWithLogoBackgroundRoot;
